export default __webpack_public_path__ + "static/media/cavinkarelogo.03264f4f.png";